import { render, staticRenderFns } from "./ProfileGift.vue?vue&type=template&id=5bc9e738"
import script from "./ProfileGift.vue?vue&type=script&lang=js"
export * from "./ProfileGift.vue?vue&type=script&lang=js"
import style0 from "./ProfileGift.vue?vue&type=style&index=0&id=5bc9e738&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports